import { render, staticRenderFns } from "./CustomerFormComponent.vue?vue&type=template&id=2abe4a44&"
import script from "./CustomerFormComponent.vue?vue&type=script&lang=js&"
export * from "./CustomerFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports